import { createSlice } from "@reduxjs/toolkit";
import { reduce } from "lodash";

const initialAnalyticsState = {
  pieRole: {
    options: {
      chart: {
        id: "apexchart-example",
        width: 380,
        type: "pie",
      },
      labels: [],
    },
    series: [],
  },
  pieRoleLoading: false,
  activeMembersYear: null,
  activeMembersMonth: null,
  activeMembersToday: null,
  usersToday: null,
  appInstallations: {
    options: {
      chart: {
        id: "apexchart-example",
        width: 380,
        type: "pie",
      },
      labels: [],
    },
    series: [],
  },
  usersPerDay: {
    series: [
      {
        name: "Registered users",
        data: [],
      },
    ],
  },
  usersPerMonth: {
    series: [
      {
        name: "Registered users",
        data: [],
      },
    ],
  },
  usersPerYear: {
    series: [
      {
        name: "Registered users",
        data: [],
      },
    ],
  },
  usersTotal: null,
  activeUsersPerYear: {
    series: [
      {
        name: "Active users",
        data: [],
      },
    ],
  },
  activeUsersPerMonth: {
    series: [
      {
        name: "Active users",
        data: [],
      },
    ],
  },
  activeUsersPerDay: {
    series: [
      {
        name: "Active users",
        data: [],
      },
    ],
  },
  error: null,
};

export const callTypes = {
  getMembersL30: "getMembersL30",
  getMembersL7: "getMembersL7",
  getMembersL24: "getMembersL24",
};

export const analyticsSlice = createSlice({
  name: "Analytics",
  initialState: initialAnalyticsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.payload.error}`;
      switch (action.payload.callType) {
        case callTypes.getMembersL30:
          state.pieRoleLoading = false;
          break;
        default:
          break;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      switch (action.payload.callType) {
        case callTypes.getMembersL30:
          state.pieRoleLoading = true;
          break;
        default:
          break;
      }
    },
    fetchedMembersL30: (state, action) => {
      const idx = state.pieRole.options.labels.indexOf(action.payload.labels);
      if (idx < 0) {
        state.pieRole.options.labels = [
          ...state.pieRole.options.labels,
          action.payload.labels + " (" + action.payload.series + " - " + action.payload.percentages + ")",
        ];
        state.pieRole.series = [
          ...state.pieRole.series,
          action.payload.series
        ];
      } else {
        state.pieRole.series[idx] = action.payload.series;
      }

      state.pieRole.options.dataLabels = {enabled: false};
      state.pieRole.options.tooltip = {enabled: false};
      state.pieRole.options.legend = {position: 'bottom'};

      state.pieRoleLoading = false;
      state.error = null;
    },
    activeMembersYear: (state, actions) => {
      state.activeMembersYear = actions.payload.activeMembersYear;
      state.error = null;
    },
    activeMembersMonth: (state, actions) => {
      state.activeMembersMonth = actions.payload.activeMembersMonth;
      state.error = null;
    },
    activeMembersToday: (state, actions) => {
      state.activeMembersToday = actions.payload.activeMembersToday;
      state.error = null;
    },
    appInstallations: (state, actions) => {
      state.appInstallations.options.labels = [
        ...state.appInstallations.options.labels,
        actions.payload.labels,
      ];
      state.appInstallations.series = [
        ...state.appInstallations.series,
        actions.payload.series,
      ];
      state.error = null;
    },
    usersTotal: (state, actions) => {
      state.usersTotal = actions.payload.usersTotal;
      state.error = null;
    },
    usersToday: (state, actions) => {
      state.usersToday = actions.payload.usersToday;
      state.error = null;
    },
    usersPerYear: (state, actions) => {
      if (state.usersPerYear.series[0].data.length < actions.payload.year) {
        while (state.usersPerYear.series[0].data.length < actions.payload.year) {
          state.usersPerYear.series[0].data.push(0);
        }
      }
      state.usersPerYear.series[0].data[actions.payload.year] = actions.payload.series;
    },
    usersPerMonth: (state, actions) => {
      if (state.usersPerMonth.series[0].data.length < actions.payload.month) {
        while (state.usersPerMonth.series[0].data.length < actions.payload.month) {
          state.usersPerMonth.series[0].data.push(0);
        }
      }
      state.usersPerMonth.series[0].data[actions.payload.month] = actions.payload.series;
    },
    usersPerDay: (state, actions) => {
      if (state.usersPerDay.series[0].data.length < actions.payload.day) {
        while (state.usersPerDay.series[0].data.length < actions.payload.day) {
          state.usersPerDay.series[0].data.push(0);
        }
      }
      state.usersPerDay.series[0].data[actions.payload.day] = actions.payload.series;
    },
    activeUsersPerYear: (state, actions) => {
      if (state.activeUsersPerYear.series[0].data.length < actions.payload.year) {
        while (state.activeUsersPerYear.series[0].data.length < actions.payload.year) {
          state.activeUsersPerYear.series[0].data.push(0);
        }
      }
      state.activeUsersPerYear.series[0].data[actions.payload.year] = actions.payload.series;
    },
    activeUsersPerMonth: (state, actions) => {
      if (state.activeUsersPerMonth.series[0].data.length < actions.payload.month) {
        while (state.activeUsersPerMonth.series[0].data.length < actions.payload.month) {
          state.activeUsersPerMonth.series[0].data.push(0);
        }
      }
      state.activeUsersPerMonth.series[0].data[actions.payload.month] = actions.payload.series;
    },
    activeUsersPerDay: (state, actions) => {
      if (state.activeUsersPerDay.series[0].data.length < actions.payload.day) {
        while (state.activeUsersPerDay.series[0].data.length < actions.payload.day) {
          state.activeUsersPerDay.series[0].data.push(0);
        }
      }
      state.activeUsersPerDay.series[0].data[actions.payload.day] = actions.payload.series;
    },
  },
});
